<div class="dashboard">
  <!-- Header com mensagem de boas-vindas -->
  <mat-toolbar class="welcome-header" color="primary">
    <div class="welcome-content">
      <mat-icon class="welcome-icon">business</mat-icon>
      <div class="welcome-text">
        <h1>
          Bem-vindo(a),
          {{ currentUser?.organizationName ?? "Cliente" }}!
        </h1>
        <p>
          Aqui você acompanha o resumo do seu contrato vigente e o status de
          utilização dos produtos DataSafra.
        </p>
      </div>
    </div>
  </mat-toolbar>

  <!-- Loading -->
  @if (loading) {
    <div class="loading-container">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p>Carregando resumo do contrato...</p>
    </div>
  }

  <!-- Error -->
  @if (error && !loading) {
    <div class="error-container">
      <p><mat-icon>error</mat-icon><br />{{ error }}</p>
      <button mat-flat-button color="primary" (click)="loadContractSummary()">
        Tentar novamente
      </button>
    </div>
  }

  <!-- Conteúdo principal -->
  @if (contractSummary && !loading) {
    <div class="dashboard-content">
      <!-- Informações do contrato -->
      <mat-card appearance="outlined" class="contract-info-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>description</mat-icon>
            Informações do Contrato
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="contract-details">
            <div class="contract-field">
              <div class="label">Modalidade:</div>
              <mat-chip
                [color]="getModalityColor(contractSummary.contractModality)"
                selected
              >
                {{ getModalityText(contractSummary.contractModality) }}
              </mat-chip>
            </div>
            <div class="contract-field">
              <div class="label">Status:</div>
              <mat-chip [color]="getContractStatus().color" selected>
                {{ getContractStatus().status }}
              </mat-chip>
            </div>
            <div class="contract-field">
              <div class="label">Data de Início:</div>
              <span>{{
                contractSummary.contractStartDate | date: "dd/MM/yyyy"
              }}</span>
            </div>
            <div class="contract-field">
              <div class="label">Data de Fim:</div>
              <span>{{
                contractSummary.contractEndDate | date: "dd/MM/yyyy"
              }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Resumo de Utilização -->
      @if (dataSource.length > 0) {
        <mat-card appearance="outlined" class="usage-summary-card">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>receipt_long</mat-icon>
              Resumo de Utilização dos Produtos
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table
              mat-table
              [dataSource]="dataSource"
              class="summary-table"
              #commit_table
            >
              <!-- Coluna Produto -->
              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>Produto</th>
                <td mat-cell *matCellDef="let element; table: commit_table">
                  <div class="product-cell">
                    <span>{{ element.product.name }}</span>
                    <small>{{ element.product.unit }}</small>
                    <small>{{ element.product.subTitle }}</small>
                  </div>
                </td>
              </ng-container>

              <!-- Coluna Contratado -->
              <ng-container matColumnDef="contracted">
                <th mat-header-cell *matHeaderCellDef class="numeric-cell">
                  Contratado
                </th>
                <td
                  mat-cell
                  *matCellDef="let element; table: commit_table"
                  class="numeric-cell"
                >
                  {{
                    element.isHectares
                      ? formatHectares(element.contracted ?? 0)
                      : element.contracted
                  }}
                </td>
              </ng-container>

              <!-- Coluna Utilizado -->
              <ng-container matColumnDef="used">
                <th mat-header-cell *matHeaderCellDef class="numeric-cell">
                  Utilizado
                </th>
                <td
                  mat-cell
                  *matCellDef="let element; table: commit_table"
                  class="numeric-cell"
                >
                  {{
                    element.isHectares
                      ? formatHectares(element.used)
                      : element.used
                  }}
                </td>
              </ng-container>

              <!-- Coluna % Utilização -->
              <ng-container matColumnDef="usagePercentage">
                <th mat-header-cell *matHeaderCellDef class="numeric-cell">
                  % Utilizado
                </th>
                <td
                  mat-cell
                  *matCellDef="let element; table: commit_table"
                  class="numeric-cell"
                >
                  <div>
                    <span
                      >{{
                        getProgressPercentage(element.used, element.contracted)
                          | number: "1.0-0"
                      }}%</span
                    >
                    <mat-progress-bar
                      [value]="
                        getProgressPercentage(element.used, element.contracted)
                      "
                      [class]="
                        getProgressColor(element.used, element.contracted)
                      "
                      mode="determinate"
                    ></mat-progress-bar>
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsWithCommitment"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsWithCommitment"
              ></tr>
            </table>
          </mat-card-content>
        </mat-card>
      }
    </div>
  }
</div>
